import React from 'react';
import { content } from "./content";
import { motion } from "framer-motion";

import { styles } from "./styles";
import { SectionWrapper } from "./hoc";
import { textVariant } from "./utils/motion";

const Badges = () => {
  const { badges } = content;
  return (
    <div>
      <motion.div variants={textVariant()}>
        <p className={`${styles.sectionSubText} text-center`}>
          What I have achieved so far
        </p>
        <h2 className={`${styles.sectionHeadText} text-center`}>
          Badges.
        </h2>

        <div className="grid grid-cols-1 mt-10 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {badges.map((bg, index) => (
            <a
              key={index}
              href={bg.link}
              target="_blank"
              rel="noreferrer"
              className="flex flex-col items-center hover:scale-105 transition-transform"
            >
              <img
                className="h-60 w-60 object-cover rounded"
                src={bg.badge}
                alt={bg.title}
              />
              <p className="text-center text-white mt-2 font-semibold font-Poppins">
                {bg.title}
              </p>
            </a>
          ))}

        </div>
      </motion.div>
    </div>
  )
}

export default SectionWrapper(Badges, 'badges');